import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { AlertService } from '../../../services/alert.service';
import { InputWrapper } from '../../common/input-wrapper';
import { FormattedMessage, useIntl } from 'react-intl';
import { DatePicker } from 'rsuite';
import moment from 'moment/moment';
import { RawDateValue } from '../../../utils/date-value';

type Form = {
  date: Date;
};

type Props = {
  close: () => void;
  reject: () => void;
  ids: number[];
  idsWithoutDates: number[];
  onSubmit: (form: Form) => Promise<void>;
};

function isCorrectDate(value: Date) {
  const parsedDate = moment(value, 'DD.MM.YYYY HH:mm', true);
  if (!parsedDate.isValid()) {
    return false;
  }

  const currentDate = moment();
  const thirtyDaysEarlier = moment().subtract(30, 'days');

  if (
    parsedDate.isAfter(currentDate) ||
    parsedDate.isBefore(thirtyDaysEarlier)
  ) {
    return false;
  }

  return true;
}

export const DeliveryOrderSendToRussiaBulk: React.FC<Props> = (props) => {
  const {
    control,
    formState: { isSubmitting },
    handleSubmit,
  } = useForm<Form>();
  const intl = useIntl();
  const onSubmit = handleSubmit(async (form) => {
    await props.onSubmit(form);
    AlertService.success();
    props.close();
  });

  return (
    <div className="modal-dialog">
      <form className="modal-content" onSubmit={onSubmit}>
        <div className="modal-header border-bottom-0 p-4">
          <h3>
            <FormattedMessage
              defaultMessage="Подтвердите отправку доставок"
              id="deliveryOrderSendToRussiaBulk.btn-label.confirmShipmentToTheRussianFederation"
              description="Надпись на кнопке/заголовок"
            />
          </h3>
          <button
            type="button"
            className="btn-close"
            onClick={() => props.reject()}
          />
        </div>
        {props.ids.length ? (
          <div className="modal-body p-4 pt-0">
            {props.ids.map((id) => {
              return (
                <div key={id} className={'text-center fs-21'}>
                  D{id}
                </div>
              );
            })}
            {props.idsWithoutDates.length ? (
              <div className="row mb-3">
                <Controller
                  name="date"
                  control={control}
                  rules={{
                    validate: (value) => {
                      if (!value)
                        return intl.formatMessage({
                          defaultMessage: 'Выберите дату',
                          id: 'deliveryOrderAssemblyModal.title.selectDate',
                          description: 'Пояснение к полю ввода',
                        });

                      if (!isCorrectDate(value))
                        return intl.formatMessage({
                          defaultMessage: 'Укажите корректную дату',
                          id: 'deliveryOrderAssemblyModal.title.selectCorrectDate',
                          description: 'Пояснение к полю ввода',
                        });

                      return true;
                    },
                  }}
                  render={({ field, fieldState }) => {
                    return (
                      <InputWrapper
                        title={intl.formatMessage({
                          defaultMessage:
                            'Укажите дату отправки для незаполненных доставок',
                          id: 'deliveryOrderSendToRussiaBulk.input-label.SpecifyTheShippingDate',
                          description: 'Заголовок поля ввода',
                        })}
                        required
                        error={fieldState.error?.message}
                      >
                        <DatePicker
                          className={'w-100'}
                          format={'dd.MM.yyyy HH:mm'}
                          placeholder={intl.formatMessage({
                            defaultMessage: 'Выберите дату',
                            id: 'deliveryOrderSendToRussiaBulk.title.SelectDate',
                            description: 'Пояснение к полю ввода',
                          })}
                          isoWeek={true}
                          onChange={(v) => {
                            field.onChange(
                              moment(v).format(
                                'DD.MM.YYYY HH:mm',
                              ) as RawDateValue,
                            );
                          }}
                          defaultValue={new Date(field.value)}
                        ></DatePicker>
                      </InputWrapper>
                    );
                  }}
                />
              </div>
            ) : null}
          </div>
        ) : null}

        <div className="modal-footer pt-3 p-4 justify-content-center d-flex gap-2">
          <div className="btn btn-light" onClick={() => props.close()}>
            <FormattedMessage
              defaultMessage="Отмена"
              id="deliveryOrder.cancel"
              description="Надпись на кнопке/вкладке"
            />
          </div>
          <button
            type="submit"
            className="btn btn-success"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              <FormattedMessage
                defaultMessage="Подтвердить отправку"
                id="deliveryAssemblyModal.btn-label.confirmShipment"
                description="Надпись на кнопке"
              />
            )}
          </button>
        </div>
      </form>
    </div>
  );
};
